import React from 'react';
import {
  TouchableOpacity,
  View,
  Text,
  Image,
  Platform,
} from '@applane/react-core-components';
import { DatePicker } from '@applane/react-date-input';
import { h10_Montessart } from '../../../theme/fonts';
import { EditableButton } from '../../buttons/Buttons';

class Modal extends React.Component {
  state = {
    date: {},
  };

  onDone = (remove) => {
    const { onApply, hideModal } = this.props;
    const { date = {} } = this.state;
    let { from, to } = date;
    if (remove === true) {
      onApply && onApply({ from: '', to: '', section: 'range' });
    } else {
      const data = { from, to, value: 'Custom' };
      if (from) {
        from = new Date(from).setHours(0, 0, 0);
        from = new Date(from);
      }
      if (to) {
        to = new Date(to).setHours(24, 0, 0);
        to = new Date(to).setHours(0, 0, 0, -1);
        to = new Date(to);
      }
      onApply && onApply({ ...data, section: 'range' });
    }

    hideModal && hideModal();
  };

  handleDate = ({ field, value }) => {
    const { date } = this.state;
    if (field === 'from') {
      date[field] = value;
    } else if (field === 'to') {
      date[field] = value;
    }
    this.setState({ date });
  };

  componentDidMount = () => {
    let { from, to } = this.props || {};
    if (from && Platform.OS === 'web') {
      from = new Date(from);
      from = from.setHours(0, 0, 0, -1) + 86400000;
      from = new Date(from);
    }
    if (to && Platform.OS !== 'web') {
      to = new Date(to);
      to = to.setHours(18, 30, 0);
      to = new Date(to);
    }

    const date = {};
    date.from = from;
    date.to = to;

    this.setState({
      date,
    });
  };

  resetDate = () => {
    const { hideModal } = this.props;
    this.onDone(true);
    hideModal && hideModal();
  };

  render() {
    const { customHeaderPopupTheme = {} } = this.props;
    const {
      titleStyle = {},
      buttonContainerStyle = {},
      titleContainerStyle = {},
      bodyContainerStyle = {},
    } = customHeaderPopupTheme;
    const {
      date: { from, to },
    } = this.state || {};
    const { frameStyle, hideModal } = this.props;

    const disable =
      this.state.date && this.state.date.from && this.state.date.to
        ? false
        : true;

    let message = '';
    if (!disable) {
      if (this.state.date.from > this.state.date.to) {
        message = 'Invalid Date Range';
      }
    }

    return (
      <View
        onPress={(e) => e.stopPropagation()}
        style={{
          ...frameStyle,
          boxShadow: '3px 3px 3px 3px grey',
          zIndex: '100'
        }}>
        <View style={titleContainerStyle}>
          <Text title="Select Range" style={{ ...titleStyle }}>
            Select Range
          </Text>
          <TouchableOpacity
            onPress={hideModal}
            style={{ cursor: 'pointer', justifyContent: 'center' }}>
            <Image
              style={{ width: 24, height: 24 }}
              resizeMode="contain"
              source={this.props.crossIcon}
            />
          </TouchableOpacity>
        </View>
        <View style={{...bodyContainerStyle,           zIndex: '100'}}>
          <View style={{ height: 20 }} />
          <DatePicker
            {...this.props}
            value={from}
            onChangeValue={(value) => this.handleDate({ field: 'from', value })}
            floatingLabelStyle={{
              ...h10_Montessart,
            }}
            activeLabelStyle={{
              ...h10_Montessart,
            }}
            label="Start Date"
          />
          <View style={{ height: 20 }} />
          <DatePicker
            {...this.props}
            value={to}
            onChangeValue={(value) => this.handleDate({ field: 'to', value })}
            floatingLabelStyle={{
              ...h10_Montessart,
            }}
            activeLabelStyle={{
              ...h10_Montessart,
            }}
            label="End Date"
          />
        </View>
        <View
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            color: 'red',
            fontSize: 18,
          }}>
          {message}
        </View>
        <View style={buttonContainerStyle}>
          <EditableButton
            onClick={this.resetDate}
            label="Reset"
            //{...(buttonStyle && buttonStyle.reset)}
            theme={{
              containerStyle: {
                border: '1px solid transparent',
                minWidth: 90,
                minHeight: 35,
                marginRight: 5,
                cursor: 'pointer',
              },
              textStyle: { color: 'blue' },
            }}
          />
          <EditableButton
            // disabled={
            //   !(this.state.date && (this.state.date.from || this.state.date.to))
            // }
            onClick={
              !disable && message === ''
                ? this.onDone
                : () => {
                    console.log('');
                  }
            }
            label="Apply"
            //{...(buttonStyle && buttonStyle.apply)}
            theme={{
              containerStyle: {
                border: '1px solid transparent',
                minWidth: 90,
                minHeight: 35,
                marginLeft: 5,
                backgroundColor: !disable && message === '' ? 'blue' : 'grey',
                cursor: 'pointer',
              },
              textStyle: { color: 'white' },
            }}
          />
        </View>
      </View>
    );
  }
}

export default Modal;
